module.exports = new Promise(resolve => {
    const script = document.createElement('script');
    script.src = 'https://claudia-app.cloudhumans.com/claudia-app/remoteEntry.js?t=' + Date.now();
    script.onload = () => resolve(window.claudiaApp);
    document.head.appendChild(script);
  });